import { createStore } from "zustand";
import { useStore } from "zustand";
import type { InitialBookSlotState, BookSlotState } from "./types";

const initialState: InitialBookSlotState = {
  timeSlotGroup: null,
  selectedDate: null,
  selectedTimeSlotId: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false,
  isBooking: false,
};

export const bookSlotStore = createStore<BookSlotState>()((set) => ({
  ...initialState,
  setTimeSlotGroup: (timeSlotGroup) =>
    set({
      timeSlotGroup,
      selectedDate: null,
      selectedTimeSlotId: null,
      errorMessage: null,
      successMessage: null,
      isLoading: false,
    }),
  clearTimeSlotGroup: () =>
    set({
      timeSlotGroup: null,
      selectedDate: null,
      selectedTimeSlotId: null,
      errorMessage: null,
      isLoading: false,
    }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setSelectedTimeSlotId: (timeSlotId) =>
    set({ selectedTimeSlotId: timeSlotId }),
  clearSelectedDate: () => set({ selectedDate: null }),
  clearSelectedTimeSlotId: () => set({ selectedTimeSlotId: null }),
  setError: (message) => set({ errorMessage: message, successMessage: null }),
  setSuccess: (message) => set({ successMessage: message, errorMessage: null }),
  clearMessages: () => set({ errorMessage: null, successMessage: null }),
  setLoading: (loading) => set({ isLoading: loading }),
  setBooking: (booking) => set({ isBooking: booking }),
}));

export const useBookSlotStore = <T>(selector: (state: BookSlotState) => T) =>
  useStore(bookSlotStore, selector);
